<template>
  <div ref="pedidos-bloqueados" data-div="pedidos-bloqueados">
    <div 
      data-div="filtro" 
      v-if="
      (
        !processando && 
        (pedidos_bloqueados_filtrados.length > 0) &&
        empresas_ids.length > 0 &&
        pagina_atual <= 1
      )" 
      v-cloak>
      
      <label data-label="filtro">Filtro</label>
      <input data-input="filtro"
        type="text"
        v-model="filtro_pedidos"
        class="w3-input w3-border w3-padding w3-margin-bottom"
        placeholder="Pesquise por pedido, vendedor ou cliente" 
      />
    </div>
      
    <div
      data-div="pedidos-bloqueados-container"
      class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left" 
      v-if="!processando && (pedidos_bloqueados_filtrados.length == 0)" v-cloak>
      
      <div data-div="pedidosbloqueados-msg" class="w3-container w3-white">
        <p>Não há pedidos bloqueados nas empresas selecionadas.</p>
      </div>
    </div>

    <div data-div="processando" v-cloak class="w3-panel w3-theme w3-card" v-if="processando">
      <p><i class="fa fa-sync-alt w3-spin"/> Processando...</p>
    </div>

    <div data-div="paginacao" v-if="!filtro_pedidos && pedidos_bloqueados_filtrados.length > 0 && total_paginas > 1">
      <button 
        data-button="botao-angle-left"
        class="w3-col w3-btn w3-theme s2 m1 menu-paginacao" 
        @click="pagina_atual = 1" 
        :disabled="pagina_atual == 1">
        <i data-i="botao-angle-left" class="fa fa-angle-double-left"/>
      </button>
        
      <button 
        data-button="botao-angle-left"
        class="w3-col w3-btn w3-theme s2 m1 menu-paginacao" 
        @click="pagina_atual -= 1" 
        :disabled="pagina_atual == 1">
        <i data-i="botao-angle-left" class="fa fa-angle-left"/>
      </button>
        
      <button 
        data-button="botao-angle-right"
        class="w3-col w3-btn w3-theme s2 m1 menu-paginacao" 
        @click="pagina_atual += 1" 
        :disabled="pagina_atual == total_paginas">
        <i data-i="botao-angle-right" class="fa fa-angle-right"/>
      </button>
        
      <button
        data-button="botao-double-right" 
        class="w3-col w3-btn w3-theme s2 m1 menu-paginacao" 
        @click="pagina_atual = total_paginas" 
        :disabled="pagina_atual == total_paginas">
        <i data-i="botao-double-right" class="fa fa-angle-double-right"/>
      </button>

      <strong 
        data-strong="numero-pagina" 
        v-if="!filtro_pedidos" 
        class="w3-right">
        {{pagina_atual}} / {{total_paginas}}
      </strong>
    </div>

    <div  
      :key="pedido.orcamento_id"
      data-div="vetor-pedidos-filtrados"
      class="w3-border w3-col active card-pedido w3-margin-top w3-padding-small"
      v-for="(pedido, indice) in novosPedidosBloqueadosFiltrados"
      v-show="(indice >= (pagina_atual * c_pedidos_por_pagina) - c_pedidos_por_pagina) && (indice < (pagina_atual * c_pedidos_por_pagina))" 
      v-cloak>
        
      <div data-div="pedido">
        <div class="w3-col">
          <legenda v-if="pedido.permitir_visualizar_lucratividade_mix == 'S'">
            <div v-if="pedido.permitir_visualizar_lucro_liquido_mix == 'S'">Resultado do Mix: %{{pedido.percentual_lucro_mix}}</div>
            <div v-if="pedido.permitir_visualizar_lucro_liquido_mix == 'N'">Resultado do Mix</div>
            <i slot="referencia" :style="getCorMixCard(pedido.cor_lucro_mix)" class="fa fa-circle w3-border"></i>
          </legenda>
          
          <label 
            class="texto-vermelho" 
            v-show="pedido.proposta_bloqueada == 'N'">
            Pedido: 
          </label>

          <label 
            class="w3-text-blue"
            v-show="pedido.proposta_bloqueada == 'S'">
            Proposta de orçamento: 
          </label>

          <strong 
            class="texto-vermelho" 
            v-show="pedido.proposta_bloqueada == 'N'">
            {{pedido.orcamento_id}}
          </strong>

          <strong 
            class="w3-text-blue" 
            v-show="pedido.proposta_bloqueada == 'S'">
            {{pedido.orcamento_id}}
          </strong>

          <label class="w3-right">
            {{pedido.data_fechamento}}
          </label>
        </div>

        <div data-div="valor-pedido" class="w3-col s12 m6 l6 texto-verde">
          <strong>R${{pedido.valor_pedido}}</strong>
        </div>
        
        <div data-div="cliente" class="w3-col s12 m6 l6">
          <legenda>
            <div>Cliente</div>
            <i slot="referencia" class="fa fa-user-tag texto-vermelho"></i>
          </legenda>
          <strong>&nbsp;{{pedido.nome_cliente}}</strong>
        </div>

        <div data-div="nome-vendedor" class="w3-col s12 m6 l6">
          <legenda>
            <div>Nome do vendedor</div>
            <i slot="referencia" class="fa fa-user-tie texto-vermelho"></i>
          </legenda>
          <label>&nbsp;&nbsp;{{pedido.nome_vendedor}}</label>
        </div>

        <div data-div="condicao-pagamento" class="w3-col s12 m6 l6">
          <legenda>
            <div>Condição de pagamento</div>
            <i slot="referencia" class="fas fa-credit-card texto-vermelho"></i>
          </legenda>
          <label>&nbsp;{{pedido.nome_condicao}}</label>
        </div>

        <div data-div="entrega" class="w3-col s12 m6 l6">
          <legenda>
            <div>Tipo de entrega</div>
            <i slot="referencia" class="fas fa-shipping-fast texto-vermelho"></i>
          </legenda>
          <label>&nbsp;{{pedido.tipo_entrega_analitico}}</label>
        </div>

        <div data-div="nome-empresa" class="w3-col s12 m6 l6">
          <legenda >
            <div>Nome da empresa</div>
            <i slot="referencia" class="fas fa-building  texto-vermelho"></i>
          </legenda>
          <label>&nbsp;&nbsp;{{pedido.nome_empresa}}</label>
        </div>

      </div>

      <div>          
        <button 
          data-button="buscar-mix"
          class="w3-button w3-theme w3-margin-top w3-col s5 m2 l2 w3-left" 
          @click="buscarMix(pedido.orcamento_id)"><i class="fas fa-chart-pie"></i>&nbsp;Mix
        </button>

        <button 
          data-button="abrir-orcamento"
          class="w3-button w3-theme w3-margin-left w3-margin-top w3-col s5 m2 l2 w3-right" 
          @click="abrirOrcamento(pedido.orcamento_id)"><i class="fas fa-file-invoice-dollar"></i>&nbsp;Pedido
        </button>
      </div>
        
      <div data-div="bloqueios" class="w3-col w3-margin-top" >
        <div 
          :key="motivo.orcamento_motivo_bloqueio_id" v-for="motivo in pedido.motivos_bloqueios"
          class="w3-margin-bottom card-bloqueios w3-border w3-padding-small"
          v-cloak>

          <div>
            <input data-input="chekbox-bloqueio"
              type="checkbox" 
              class="w3-check"
              :id="'bloqueio' + pedido.orcamento_id + motivo.orcamento_motivo_bloqueio_id"
              v-model="motivo.liberado">

            <label data-label="tipo" :for="'bloqueio' + pedido.orcamento_id + motivo.orcamento_motivo_bloqueio_id">Tipo:</label>

            <label data-label="motivo-bloqueio" :for="'bloqueio' + pedido.orcamento_id + motivo.orcamento_motivo_bloqueio_id">
              <strong>{{motivo.tipo_analitico}}</strong>
            </label>
          </div>
            
          <div data-div="motivo" style="margin-top: 5px;">
            <label>Motivo: </label>
            <strong>{{motivo.motivo}}</strong>
          </div>

          <div style="margin-top: 5px;">
            <label>Informações adicionais: </label>
            <pre style="margin-top: 0px; margin-bottom: 0px; font-family: Roboto, sans-serif; font-size: 14px; font-weight: bold;" class="box-mensagem">{{motivo.informacao_adicional.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10))}}</pre>
          </div>

        </div>  
      </div>

      <div class="w3-row">
        <div class="w3-col s12" style="margin-bottom: 5px">
          <button 
            data-button="liberar-pedido"
            class="w3-button w3-col w3-green s12 m4 w3-left w3-margin-right" style="margin-top:5px"
            @click="liberarPedido(pedido.orcamento_id, pedido.proposta_bloqueada)">
            <i class="fas fa-check"/>&nbsp;Liberar pedido
          </button>

          <button 
            data-button="voltar-orcamento"
            class="w3-button w3-border w3-text-theme w3-col s12 m4 w3-right w3-margin-left " style="margin-top:5px"
            @click="voltarOrcamento(pedido.orcamento_id, pedido.proposta_bloqueada)">
            <i class="fas fa-undo-alt"/>&nbsp;Voltar orçamento
          </button>   
        </div>
      </div>

    </div>
    
    <modal-mix 
      data-modal-mix="componente-mix" :mix="mix"
      style="max-width:100vw!important;"
      v-if="mostrarModalMix" @close="mostrarModalMix = false"
    />

    <dados-orcamento 
      style="max-width:100vw!important;"
      data-dados-orcamento="componente-orcamento"
      :orcamento_dados="orcamento_detalhe" 
      v-if="mostrarModalDadosOrcamento" 
      @close="mostrarModalDadosOrcamento = false"
    />
    
    <div data-div="modal-voltar-pedido" id="modalVoltarPedido" class="w3-modal conteudo-centralizado">
      <div class="w3-modal-content w3-animate-zoom">

        <header class="w3-container">
          <span
            onclick="document.getElementById('modalVoltarPedido').style.display='none'"
            class="w3-button w3-display-topright">&times;
          </span>
          <h2>Motivo do cancelamento de pedido</h2>
        </header>

        <div class="w3-container">
          <br>
          <strong>Motivo do cancelamento de pedido</strong>
          <textarea 
            class="w3-input w3-block w3-border" 
            id="observacoes-desbloqueio" 
            rows="3" 
            v-model="motivo_cancelamento"
          />
        </div>

        <footer class="w3-container">
          <button 
            data-button="voltar-orcamento"
            class="w3-button w3-theme w3-left" 
            id="btn-confirmar-acao" 
            style="margin-top: 10px; margin-bottom:10px" 
            @click.prevent="voltarOrcamento(orcamento_voltar_id)">Confirmar
          </button>

          <button 
            data-button="cancelar-orcamento"
            class="w3-button w3-text-theme w3-border w3-right" 
            style="margin-top: 10px; margin-bottom:10px" 
            onclick="document.getElementById('modalVoltarPedido').style.display='none'">Cancelar
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
  import Legenda from '@/components/Legendas'
  import ModalMix from '@/components/ModalMix'
  import RBuscarMix from '@/components/Rest/RBuscarMix.js'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import DadosOrcamento from '@/components/Orcamentos/DadosOrcamento'
  import ROrcamentoLiberarBloqueiosPedido from '@/components/Rest/ROrcamento/ROrcamentoLiberarBloqueiosPedido.js'
  import ROrcamentoBuscarPedidosBloqueados from '@/components/Rest/ROrcamento/ROrcamentoBuscarPedidosBloqueados.js'
  import ROrcamentoCancelarFechamentoPedido from '@/components/Rest/ROrcamento/ROrcamentoCancelarFechamentoPedido.js'

  export default {
  name: 'PedidosBloqueados',
  components: {
    ModalMix, 
    DadosOrcamento, 
    Legenda,
  },
    
  data() {
    return {
      api: process.env.API,
      pedidos_bloqueados_filtrados: [],
      empresas_autorizadas: [],
      mix: {},
      motivo_desbloqueio: '',
      motivo_cancelamento: '',
      orcamento_liberar_id: 0,
      orcamento_voltar_id: 0,
      processando: false,
      confirmar_liberacao: false,
      filtro_pedidos: '',
      mostrar: false,
      mostrarModalMix: false,
      mostrarModalDadosOrcamento: false,
      orcamento_detalhe: {},
      liberado: false,
      pedido:'',
      empresas_ids: [],
      situacao:'',

      /* PAGINAÇÃO */
      pagina_atual: 0,
      quantidade_pedidos: 0,
      total_paginas: 0,

      /* CONSTANTES */
      c_pedidos_por_pagina: 5
    }
  },
 
  methods: {
    getCorMixCard: function(situacao){
        return 'color:' + situacao+'!important; border: 3px; border-radius: 100%;';
    },
    /* PAGINAÇÃO */
    mudarPagina(numeroDaPagina) {
      this.pagina_atual = numeroDaPagina;
    },

    async definirEmpresasIds(v_empresas_ids) {
      this.empresas_ids = v_empresas_ids;
      await this.buscarPedidosBloqueados();
    },
    
    async buscarPedidosBloqueados() {
      try {

        if ((!this.empresas_ids) || (this.empresas_ids.length == 0)) {
          return;
        }

        this.processando = true;
        this.pedidos_bloqueados = {};
        this.pedidos_bloqueados_filtrados = {};
      
        let parametros = {
          empresas_ids: this.empresas_ids
        };
       
        let retorno = await ROrcamentoBuscarPedidosBloqueados.buscarPedidosBloqueados(
          this.axios, 
          parametros
        );
       
        if (retorno.houve_erro == 'S'){
          throw new Error(retorno.mensagem);
        }

        if (retorno.dados) {
          this.pedidos_bloqueados_filtrados = retorno.dados.pedidos_bloqueados;
  
          for (let i = 0; i < this.pedidos_bloqueados_filtrados.length; i++) {
            for (let j = 0; j < this.pedidos_bloqueados_filtrados[i].motivos_bloqueios.length; j++) {
              this.pedidos_bloqueados_filtrados[i].motivos_bloqueios[j].liberado = false;
            }
          }
          
          this.pagina_atual = 1;
          this.quantidade_pedidos = this.pedidos_bloqueados_filtrados.length;
          this.total_paginas = Math.ceil(this.quantidade_pedidos / this.c_pedidos_por_pagina);
        }

        this.processando = false;
      } catch (error) {
        this.verificarErro(error, 'buscarPedidosBloqueados');
      }
    },

    async buscarMix(orcamento_id) {   
      try {
        let parametros = { 
          orcamento_id: orcamento_id
        };

        let retorno = await RBuscarMix.buscarMix(this.axios, parametros);

        if (retorno.houve_erro == 'S') {
          throw new Error(retorno.mensagem);
        }

        this.mix = retorno.dados;
        this.mostrarModalMix = true;
      } catch (error) {
        this.verificarErro(error, 'buscarMix');
      }
    },

    abrirOrcamento(orcamento_id){
      this.orcamento_detalhe = orcamento_id;
      this.mostrarModalDadosOrcamento = true; 
    },

    liberarPedido(orcamento_id, proposta_bloqueada) {

      let parametros = {
        orcamento_id: orcamento_id,
        proposta_bloqueada: proposta_bloqueada,
        orcamento_motivos_desbloquear_ids: []
      }

      for (let i = 0; i < this.pedidos_bloqueados_filtrados.length; i++) {

        if (this.pedidos_bloqueados_filtrados[i].orcamento_id != orcamento_id) {
          continue;
        }

        for (let j = 0; j < this.pedidos_bloqueados_filtrados[i].motivos_bloqueios.length; j++) {
          if (this.pedidos_bloqueados_filtrados[i].motivos_bloqueios[j].liberado == true) {
              parametros.orcamento_motivos_desbloquear_ids.push(
              this.pedidos_bloqueados_filtrados[i].motivos_bloqueios[j].orcamento_motivo_bloqueio_id
            )
          }
        }
      }

      if (parametros.orcamento_motivos_desbloquear_ids.length == 0){
        Biblioteca.exclamar('É necessário informar ao menos um motivo para liberar!');
        return;
      }

      this.confirmar_liberacao = true;

      swal({
        title: 'Confirmar Liberação',
        className: 'swal-modal',
        buttons: ["Cancelar", "Confirmar"],
        showCloseButton: true,
        text: "Observações das liberações",
        focusConfirm: false,
        content: {
          element: "textarea",
          attributes: {
            rows: 3,
            class: 'w3-input',
          }
        }
      }).then(async (isConfirm) => {
        if (!isConfirm) {
          return false;
        }

        try {
          parametros.observacoes_desbloqueio = document.querySelector('.swal-modal .swal-content__textarea').value;
          let retorno = await ROrcamentoLiberarBloqueiosPedido.liberarBloqueiosPedido(this.axios, parametros);
          
          if (retorno.houve_erro != 'N'){
            swal(retorno.mensagem);
            return;
          } 
          
          Biblioteca.informar('Procedimento realizado com sucesso!');
          
          this.confirmar_liberacao = false;
          this.motivo_desbloqueio = '';
          this.buscarPedidosBloqueados();
        } catch (error) {
          this.verificarErro(error, 'liberarPedido');
        } 
      }) 
    },
  
    modalVoltarPedido(orcamento_id){
      this.orcamento_voltar_id = orcamento_id;
      $('html,body').animate({scrollTop: ($("#modalVoltarPedido")).offset().top});
      document.getElementById('modalVoltarPedido').style.display = "block";
    },

   voltarOrcamento: function(orcamento_id, proposta_bloqueada){
      swal(
        proposta_bloqueada == 'S' ? 
        'Deseja realmente cancelar a proposta de orçamento (automaticamente ela voltará para edição)?':
        'Deseja realmente cancelar o fechamento deste pedido (ele automaticamente voltará a ser um orçamento)?', 
        {
          buttons: {
            sim: "Sim",
            nao: "Não"
          },
        }
      )
      .then((value) => {
        if (value == 'nao'){
          return;
        }

        const self = this;
	
        swal({
          title: 'Motivo de cancelamento',
          className: 'swal-modal',
          buttons: ["Cancelar", "Confirmar"],
          showCloseButton: true,
          text: "Observações do cancelamento",
          focusConfirm: false,
          content: {
            element: "textarea",
            attributes: {
              rows: 3,
              class: 'w3-input',
            }
          }
        }).then(
          async (isConfirm) => {
            if (isConfirm) {
              try {

                let parametros = {
                  orcamento_id: orcamento_id,
                  proposta_bloqueada: proposta_bloqueada,
                  motivo: document.querySelector('.swal-modal .swal-content__textarea').value
                }

                let retorno = await ROrcamentoCancelarFechamentoPedido.cancelarFechamentoPedido(this.axios, parametros);
                
                if (retorno.houve_erro != 'N'){
                  swal(retorno.mensagem);
                  return;
                }

                Biblioteca.informar('Procedimento realizado com sucesso!');
                self.$emit('voltarPedido');

                self.buscarPedidosBloqueados();
                self.motivo_cancelamento = '';
              } catch (error) {
                this.verificarErro(error, 'voltarOrcamento');
              }
            } else {
              return false;
            }
          }
        );
      })
    },

    verificarErro(erro, nome_funcao){
      this.processando = false;
      this.confirmar_liberacao = false;
      Biblioteca.gerarLogNomeFuncao('PedidosBloqueados.vue -> ' + nome_funcao);
      Biblioteca.exclamar(erro.message);
    },
  },

  computed: {
   /* Filtro */
    novosPedidosBloqueadosFiltrados() {
     if ((!this.filtro_pedidos) || (this.filtro_pedidos.trim() == '')) {
        return this.pedidos_bloqueados_filtrados;
      }
     
      let retorno = [];

      for (let i = 0; i < this.pedidos_bloqueados_filtrados.length; i++) {
        let pedido_enquadra_filtro_orcamento = false;

        if (
          /* Pedido - Ignorando ponto */
          (
            (this.pedidos_bloqueados_filtrados[i].orcamento_id) && 
            (this.pedidos_bloqueados_filtrados[i].orcamento_id.replace('.', '').includes((this.filtro_pedidos.replace('.', ''))))
          ) ||

          /* Cliente */
          (
            (this.pedidos_bloqueados_filtrados[i].nome_cliente) && 
            (this.pedidos_bloqueados_filtrados[i].nome_cliente.includes(this.filtro_pedidos.toUpperCase()))
          ) ||
          
          /* Vendedor */
          (
            (this.pedidos_bloqueados_filtrados[i].nome_vendedor) && 
            (this.pedidos_bloqueados_filtrados[i].nome_vendedor.includes(this.filtro_pedidos.toUpperCase()))
          )
        ) {
          pedido_enquadra_filtro_orcamento = true;
        }

        if (pedido_enquadra_filtro_orcamento) {
          retorno.push(this.pedidos_bloqueados_filtrados[i]);
        }
      }
      return retorno;
    },
  },

  created() {
    this.buscarPedidosBloqueados();
  }
}
</script>

<style scoped>
  textarea { 
    resize:vertical;
  }
  .card-bloqueios {
    border-radius: 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    background-color: #f3f3f3;
    border-bottom: 0px dotted #666666;
  }
  .card-pedido{
    border-radius: 10px;
    box-shadow: #dddddd 1px 3px 5px 3px ;
  }
  .texto-verde{
    color: green;
  }
  .menu-paginacao {
    margin-right: 2px;
  }
  .tituloModal{
    font-size: 1px!important;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/PedidosBloqueados.vue